import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import aboutImage from '@/assets/images/about.jpg';

const values = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Alma',
    desc: 'Paixão genuína por cada projeto. Nos envolvemos de verdade com o negócio do cliente para entregar soluções que fazem diferença.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Dados',
    desc: 'Decisões orientadas por dados. Coletamos, processamos e transformamos informação em vantagem competitiva real.',
  },
  {
    icon: 'ri-settings-4-line',
    title: 'Tecnologia',
    desc: 'Ferramentas certas para cada desafio. IA, automação, cloud e software aplicados de forma inteligente e estratégica.',
  },
];

// const stats = [
//   { value: '50+', label: 'Empresas Atendidas' },
//   { value: '120+', label: 'Projetos Entregues' },
//   { value: '98%', label: 'Satisfação dos Clientes' },
//   { value: '8+', label: 'Anos no Mercado' },
// ];

export default function AboutSection() {
  const { ref, visible } = useScrollAnimation();
  const { ref: ref2, visible: visible2 } = useScrollAnimation();

  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div ref={ref} className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <span className="inline-block text-emerald-600 font-semibold text-sm font-inter tracking-widest uppercase mb-3">Quem Somos</span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">Sobre a Almadata</h2>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto" />
        </div>

        {/* Content split */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16">
          {/* Text */}
          <div className={`transition-all duration-700 delay-150 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <h3 className="font-sora font-bold text-2xl md:text-3xl text-zinc-900 mb-5 leading-snug">
              Tecnologia com <span className="text-emerald-500">propósito</span>,<br />resultados com <span className="text-emerald-500">significado</span>
            </h3>
            <p className="font-inter text-zinc-600 text-base leading-relaxed mb-5">
              A <strong>Almadata</strong> nasceu da fusão do sobrenome <em>Almada</em> com <em>data</em> (dados) e <em>alma</em> — valores que definem nossa essência. Somos uma empresa que usa tecnologia de forma inteligente para agregar valor real ao negócio dos nossos clientes.
            </p>
            <p className="font-inter text-zinc-600 text-base leading-relaxed mb-5">
              Não entregamos apenas software ou relatórios. Nos aprofundamos no modelo de negócio do cliente, entendemos seus desafios, e aplicamos as melhores ferramentas — seja <strong>Inteligência Artificial</strong>, automação, desenvolvimento de software ou consultoria — para tornar a empresa mais eficiente, produtiva e competitiva.
            </p>
            <p className="font-inter text-zinc-600 text-base leading-relaxed">
              Nossa equipe multidisciplinar combina experiência de mercado com as tecnologias mais modernas, sempre com um olhar estratégico e humano sobre cada projeto.
            </p>
          </div>

          {/* Image */}
          <div className={`transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="relative rounded-2xl overflow-hidden w-full h-80 md:h-96">
              <img
                src={aboutImage}
                alt="Equipe Almadata trabalhando"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/20 to-transparent" />
            </div>
          </div>
        </div>

        {/* Values */}
        <div ref={ref2} className={`grid grid-cols-1 sm:grid-cols-3 gap-6 mb-16 transition-all duration-700 ${visible2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {values.map((v, i) => (
            <div
              key={v.title}
              className="rounded-xl border border-zinc-100 bg-zinc-50 p-6 transition-all duration-300 hover:-translate-y-1"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-11 h-11 flex items-center justify-center bg-emerald-100 rounded-xl mb-4">
                <i className={`${v.icon} text-emerald-600 text-xl`} />
              </div>
              <h4 className="font-sora font-semibold text-zinc-900 text-base mb-2">{v.title}</h4>
              <p className="font-inter text-zinc-600 text-sm leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats bar
        <div className={`grid grid-cols-2 lg:grid-cols-4 gap-6 bg-emerald-950 rounded-2xl p-8 md:p-10 transition-all duration-700 delay-200 ${visible2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-sora font-bold text-3xl md:text-4xl text-emerald-400 mb-1">{s.value}</p>
              <p className="font-inter text-emerald-100/60 text-sm">{s.label}</p>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
}
